export default __webpack_public_path__ + "static/media/devices.99f78ca4.svg";